import styled from '@emotion/styled';
import { css } from '@emotion/react';
import COLORS from '../../styles/emotion/colors';
import FONTS from '../../styles/emotion/fonts';
import MEDIA_QUERY from '../../styles/emotion/mediaQuery';

export const SegmentControl = styled.div<{
  ready?: boolean;
  activeWidth?: number;
  activeTranslateX?: number;
}>`
  background-color: #efeff0;
  border-radius: 9px;
  display: flex;
  justify-content: center;
  margin: 0 auto 20px;
  padding: 2px;
  width: fit-content;
  position: relative;
    ${(props) =>
      props.ready &&
      `
      &::before {
        content: '';
        background-color: ${COLORS.WHITE};
        border-radius: 7px;
        box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.12), 0 3px 1px 0 rgba(0, 0, 0, 0.04);
        width: ${props.activeWidth ? `${props.activeWidth}px` : '0'};
        transform: translateX(
          ${props.activeTranslateX ? `${props.activeTranslateX}px` : '0'}
        );
        position: absolute;
        top: 2px;
        bottom: 2px;
        left: 0;
        right: 0;
        z-index: 0;
        transition: transform 0.3s ease, width 0.3s ease;
      `};
  }
`;

export const Segment = styled.button<{
  isActive?: boolean;
}>`
  border: none;
  background-color: transparent;
  color: ${COLORS.BOULDER};
  cursor: pointer;
  display: flex;
  font-size: ${FONTS.FONT_SIZE_SMALLER};
  font-weight: ${FONTS.FONT_WEIGHT_SEMI_BOLD};
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  line-height: 28px;
  text-align: center;
  min-width: 135px;
  padding: 0 10px;
  z-index: 1;
  transition: color 0.3s ease;
  outline: revert;
  ${(props) =>
    props.isActive &&
    `
      color: ${COLORS.BLACK};
    `};
  ${MEDIA_QUERY.MOBILE} {
    min-width: 96px;
  }
  ${MEDIA_QUERY.MOBILE_XS} {
    min-width: fit-content;
  }
`;

export const IconCss = css`
  margin-right: 4px;
  display: flex;
`;
